module.exports = "/static/assets/c1ba16dba17e433fb784331c76973bcc.png";